<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model.contractDetail" :rules="validatorRules" slot="detail" :colon="false">
        <Detail ref="detailRef" v-show="showDetail" />

        <!-- <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item label="审核意见" prop="audit">
              <a-radio-group v-model="model.audit">
                <a-radio :value="1">通过</a-radio>
                <a-radio :value="0">驳回</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="备注" prop="remark1">
              <a-textarea v-model="model.remark1" placeholder="请输入备注信息" :rows="4" />
            </a-form-model-item>
          </a-col>
        </a-row> -->

          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('合同名称')" prop="contractName">
                <!-- <a-input v-model="model.contractName" placeholder="请输入合同名称"></a-input> -->
                <el-input type="text" size="small" v-model.trim="model.contractDetail.contractName" :placeholder="$t('请输入合同名称')" maxlength="20" show-word-limit />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('合同金额(元)')" prop="contractAmount">
                <!-- <a-input-number v-model="model.contractAmount" placeholder="请输入合同金额" style="width: 100%" /> -->
                <el-input type="number" size="small" v-model.trim="model.contractDetail.contractAmount" :placeholder="$t('请输入合同金额')" maxlength="20" show-word-limit />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('甲方')" prop="partyA">
                <!-- <a-input v-model="model.partyA" placeholder="请输入甲方"></a-input> -->
                <el-input type="text" size="small" v-model.trim="model.contractDetail.partyA" :placeholder="$t('请输入甲方')" maxlength="20" show-word-limit />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('乙方')" prop="partyB">
                <!-- <a-input v-model="model.partyB" placeholder="请输入乙方"></a-input> -->
                <el-input type="text" size="small" v-model.trim="model.contractDetail.partyB" :placeholder="$t('请输入乙方')" maxlength="20" show-word-limit />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('备注说明')" prop="remark">
                <a-textarea v-model="model.contractDetail.remark" :placeholder="$t('请输入备注信息')" :rows="4"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item :label="$t('费用已收取')" prop="isCharge">
                <a-radio-group v-model="model.contractDetail.isCharge">
                  <a-radio :value="1">{{ $t('是') }}</a-radio>
                  <a-radio :value="0">{{ $t('否') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <!-- 单据类型为 用水  用水类型为 临时用水 则 需要录入预存金额 -->
            <a-col :span="8" v-if="ticketsData.ticketsType == 5 && model.whetherUseWaterTemporarily == 1" >
              <a-form-model-item :label="$t('预存金额(元)')" prop="preDepositedAmount">
                <!-- <a-input-number v-model="model.contractAmount" placeholder="请输入合同金额" style="width: 100%" /> -->
                <el-input type="number" size="small" v-model.trim="model.contractDetail.preDepositedAmount" :placeholder="$t('请输入预存金额')" maxlength="20" show-word-limit />
              </a-form-model-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            
            <a-col :span="8">
              <a-form-model-item :label="$t('合同附件')" prop="contractAnnex">
                <JUpload v-model="fileList1" accept=".pdf,.doc,.docx,.xls,.xlsx" @change="uploadChange1"/>
              </a-form-model-item>
            </a-col>
           
            <a-col :span="8">
              <a-form-model-item :label="$t('费用附件')" prop="expensesAnnex">
                <JUpload v-model="fileList" accept=".pdf,.doc,.docx,.xls,.xlsx" @change="uploadChange"/>
              </a-form-model-item>
            </a-col>

            <!-- <a-col :span="8">
              <a-form-model-item label="缴费证明" prop="inspectionPicture">
                <j-image-upload class="avatar-uploader" text="缴费证明" :isMultiple="true" v-model="model.personalDealDetail.inspectionPicture"></j-image-upload>
              </a-form-model-item>
            </a-col> -->

          </a-row>
          
          <!-- <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item label="下一节点操作人" prop="candidateUsers">
                <a-select mode="multiple" placeholder="请选择操作人" v-model="model.candidateUsers">
                  <a-select-option :value="item.userName" v-for="item in candidateUsersList">{{item.userRealname}}</a-select-option>
                </a-select> 
              </a-form-model-item>
            </a-col>
          </a-row> -->
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction, postAction } from '@/api/manage'
  import { validateDuplicateValue,historyFileUrl } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import Detail from '../detail'

  export default {
    name: 'ConstructionDetailForm',
    components: {
      JUpload,
      JImageUpload,
      Detail
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        confirmLoading: false,
        showDetail: false,
        remarkRequired: true,
        url: {
          add: "/jeecg-engineering/engineering/contractDetail/add",
          edit: "/jeecg-engineering/engineering/contractDetail/edit",
          queryById: "/jeecg-engineering/ticket/tickets/queryById",
          pass: "/jeecg-engineering/flowable/task/completeByDateId",
          queryByInstallationId: "/jeecg-engineering/engineering/contractDetail/queryByInstallationId",
          list: "/jeecg-engineering/engineering/contractDetail/list",
          upload: "sys/common/upload",
          // userList: "/jeecg-engineering/flowable/definition/userList",
          userList: "/jeecg-engineering/ticket/ticketsUser/list",
          reject: "/jeecg-engineering/flowable/task/taskRejectByDataId",
          editApproverName: "/jeecg-engineering/ticket/tickets/editApproverName"
        },
        fileList: [],
        fileList1: [],
        ticketsData: {},
        bool: false,
        candidateUsersList:[]
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      validatorRules () {
        return {
          audit:{ required: true,message: this.$t('请选择审批意见'), trigger: 'change' },
          remark1:{ required: this.remarkRequired,message: this.$t('请输入备注'),trigger: 'input' },
          isCharge:[
            { required: true, message: this.$t('请选择是否已收取费用'), trigger: 'change' },
          ],
          contractName: [{ required: true, message: this.$t('请输入合同名称') },],
          contractAmount: [{ required: true, message: this.$t('请输入合同金额') },],
          candidateUsers:{ required: true,message: this.$t('请选择下一节点操作人'), trigger: 'change' },
          partyA:{ required: true,message: this.$t('请输入甲方')},
          partyB:{ required: true,message: this.$t('请输入乙方')}
        }
      },
    },
    watch:{
      'model.audit':{
        handler(val){
          if(val == 1){
            this.remarkRequired = false;
          }else{
            this.remarkRequired = true;
          }
        }
      }
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      getUserList(){
        getAction(this.url.userList,{pageSize:999}).then(res=>{
          if(res.success){
            this.candidateUsersList = res.result.records;
          }
        })
      },
      uploadChange1(file){
        this.$set(this.model.contractDetail,'contractAnnex',file);
        this.$nextTick(()=>{
          this.$refs.form.validateField('contractAnnex');
        })
      },
      uploadChange(file){
        this.$set(this.model.contractDetail,'expensesAnnex',file);
        this.$nextTick(()=>{
          this.$refs.form.validateField('expensesAnnex');
        })
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record,bool) {
        let that = this;
        
        this.bool = bool;
        this.model = Object.assign({});
        // 清除表单验证
        this.$nextTick(()=>{
          this.$refs.form.clearValidate();
        })

        if(record.id){
          // 获取详情信息
          getAction(this.url.queryById,{id:record.id}).then(res=>{
            if(res.success){
              that.ticketsData = { ...res.result }
              // 报装 设计预算信息
              that.model = { 
                ...res.result.installationDetail,
                // dataId:  res.result.id,
                // installationId:  res.result.ticketsForeignId,
                // ticketsId:  res.result.id,
               }
               if (that.model.contractDetail.expensesAnnex == null) {
                  that.fileList = []
                } else {
                  that.fileList = [that.model.contractDetail.expensesAnnex];
                }
                if (that.model.contractDetail.contractAnnex == null) {
                  that.fileList1 = []
                } else {
                  that.fileList1 = [that.model.contractDetail.contractAnnex];
                }
                // 确保子组件已挂载
                that.$nextTick(() => {
                  if(that.$refs.detailRef) {
                    that.$refs.detailRef.init(that.ticketsData, bool);
                    that.showDetail = true;
                  } else {
                    console.error('子组件引用不存在');
                  }
                });
            }
          })
        }
        this.getUserList();
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = this.url.pass;
            let method = 'post';
            let message = this.$t('处理成功');

            let params = {
                dataId: that.ticketsData.id,
                createTicketDTO:{
                  ticketsInstallationReq: {
                    ...that.model
                  },
                },
                comment: ''
              }

            httpAction(httpurl,params,method).then((res) => {
              if (res.success) {
                that.$message.success(message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
              that.confirmLoading = false;
            }).finally(() => {
              that.confirmLoading = false;
            })
            
          }
        })
      },
    }
  }
</script>
<style>
  .lab-title{
    font-weight: bold;
    color: #000;
  }
</style>